import { StringOptions } from "../../components/Select";
import { OrderType } from "../../services";
import { TransactionType } from "../../utils";

export interface TransactionsPageProps {
  accountId?: number;
  accountName?: string;
  showTitle: boolean;
  isAccountActive?: boolean;
  requestAccount?: () => void;
}

export interface TransactionTypesOptions {
  value: TransactionType;
  label: string;
}

export type PanelAction = "edit" | "duplicate" | "create";

export interface Category {
  value: string;
  label: string;
  isIncome: boolean;
  subCategories: SubCategory[];
}

export interface SubCategory {
  value: string;
  label: string;
}

export enum SortValueType {
  TRANSACTION_DATE = "transactionDate",
  AMOUNT = "amount",
  CATEGORY = "category",
}

export interface SortConfig {
  field: SortValueType;
  order: OrderType;
}

export interface GetTransactionsProps extends GetTransactionsTotalsProps {
  sortBy: SortValueType;
  orderBy: OrderType;
  page: number;
  rowsPerPage: number;
}

export interface GetTransactionsTotalsProps {
  type: TransactionType[];
  categoryId?: number;
  searchBy: string;
  accountId?: number;
  cashbackBuysOf?: number;
  dateRange?: string;
  year?: number;
  month?: number;
  limit?: number;
  specificYear?: number;
}

export type GroupBy = "type" | "category" | "subcategory";

export interface GetGroupedTransactionsProps extends GetTransactionsTotalsProps {
  groupBy: GroupBy;
}

export interface GetCashflowSeriesProps {
  bucket: "day" | "week" | "month" | "year";
  from: string; // YYYY-MM-DD
  to: string; // YYYY-MM-DD
  type: TransactionType[];
  categoryId?: number;
  searchBy?: string;
  accountId?: number;
}

export interface Filters {
  searchBy: string;
  transactionType: StringOptions;
  dateRange: StringOptions;
  month: StringOptions;
  year: StringOptions;
  page: number;
  rowsPerPage: number;
  category: StringOptions | null;
}

export interface TransactionFiltersProps {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  hasActiveFilters: boolean;
  clearAllFilters: () => void;
  filterYears: StringOptions[];
  categoryOptions: StringOptions[];
  filtersDisabled?: boolean;
}

export type TabId = "transactions" | "recurring" | "graph";
